module.exports = __webpack_public_path__ + "img/gitlab.6dd5152.png";